export default __webpack_public_path__ + "static/discordScreenshot-7a8fe49ef75fd00ab8d47ebcfb283e49.png";